import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=05f5c906&scoped=true&"
import script from "./PositionEdit.vue?vue&type=script&lang=ts&"
export * from "./PositionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PositionEdit.vue?vue&type=style&index=0&id=05f5c906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5c906",
  null
  
)

export default component.exports